module.exports = __webpack_public_path__ + "static/media/S47.85c046e5.png";